var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_537_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7378 11.2058C21.7378 10.3045 21.6647 9.64674 21.5064 8.96466H11.2141V13.0328H17.2555C17.1337 14.0438 16.476 15.5663 15.0143 16.5894L14.9938 16.7256L18.2481 19.2466L18.4735 19.2691C20.5441 17.3568 21.7378 14.5432 21.7378 11.2058Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2141 21.9244C14.1739 21.9244 16.6586 20.95 18.4736 19.2691L15.0143 16.5894C14.0887 17.235 12.8463 17.6857 11.2141 17.6857C8.31526 17.6857 5.85488 15.7734 4.97781 13.1303L4.84926 13.1412L1.46546 15.76L1.4212 15.883C3.22386 19.464 6.92666 21.9244 11.2141 21.9244Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97778 13.1303C4.74636 12.4482 4.61243 11.7174 4.61243 10.9622C4.61243 10.207 4.74636 9.47621 4.9656 8.79413L4.95947 8.64886L1.53327 5.98804L1.42117 6.04136C0.678205 7.52737 0.251892 9.19609 0.251892 10.9622C0.251892 12.7284 0.678205 14.397 1.42117 15.883L4.97778 13.1303Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2141 4.23869C13.2726 4.23869 14.6611 5.12785 15.4528 5.87089L18.5466 2.85018C16.6465 1.08405 14.1739 0 11.2141 0C6.92666 0 3.22386 2.46039 1.4212 6.04135L4.96564 8.79412C5.85488 6.15102 8.31526 4.23869 11.2141 4.23869Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_537_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.cef7a596aa1a7c5d3d347941635b6038.svg";
export { ForwardRef as ReactComponent };